module.exports = __webpack_public_path__ + "img/info_txt_01.04118fa7.png";